/**
 * ÇEVRİMDIŞI DEPO — IndexedDB üzerinde küçük bir anahtar/değer deposu.
 *
 * Çevrimdışı çalışmanın iki kaydı burada: sorgu önbelleğinin kopyası
 * (`sorgular`) ve sunucuya gönderilmeyi bekleyen yazmalar (`kuyruk`).
 * `localStorage` yetmiyor: birkaç dosyanın formları, kontrol listeleri ve
 * şemaları birkaç MB'ı buluyor, `localStorage` ise ~5 MB ile sınırlı ve
 * eşzamanlı.
 *
 * IndexedDB kapalıysa (gizli pencere, eski tarayıcı) her işlem sessizce
 * boşa düşer: uygulama yine çalışır, yalnız çevrimdışı desteği olmaz.
 */

const VT_ADI = "audex-cevrimdisi"
const DEPO = "kv"

let vt: Promise<IDBDatabase | null> | null = null

function ac(): Promise<IDBDatabase | null> {
  if (vt) return vt
  vt = new Promise((coz) => {
    try {
      if (typeof indexedDB === "undefined") return coz(null)
      const istek = indexedDB.open(VT_ADI, 1)
      istek.onupgradeneeded = () => istek.result.createObjectStore(DEPO)
      istek.onsuccess = () => coz(istek.result)
      istek.onerror = () => coz(null)
      istek.onblocked = () => coz(null)
    } catch {
      coz(null)
    }
  })
  return vt
}

function islem<T>(kip: IDBTransactionMode, is: (d: IDBObjectStore) => IDBRequest<T>): Promise<T | undefined> {
  return ac().then(
    (db) =>
      new Promise<T | undefined>((coz) => {
        if (!db) return coz(undefined)
        try {
          const istek = is(db.transaction(DEPO, kip).objectStore(DEPO))
          istek.onsuccess = () => coz(istek.result)
          istek.onerror = () => coz(undefined)
        } catch {
          coz(undefined)
        }
      }),
  )
}

export const depoOku = <T>(anahtar: string) => islem<T>("readonly", (d) => d.get(anahtar) as IDBRequest<T>)
export const depoYaz = (anahtar: string, deger: unknown) => islem("readwrite", (d) => d.put(deger, anahtar)).then(() => undefined)
export const depoSil = (anahtar: string) => islem("readwrite", (d) => d.delete(anahtar)).then(() => undefined)
